module.exports = __webpack_public_path__ + "img/220.acf84c64.png";